import type { Address } from "@jti/fe-common/types";
import type { ApiMagentoAddress } from "@jti/magento-types";

export const profileAddressToMagentoAddressAdapter = (
  address: Address,
  saveInAddressBook = false
): ApiMagentoAddress => {
  const {
    isPickupAddress = false,
    pickupInformation,
    city,
    countryCode,
    streetName,
    streetNumber,
    streetAdditional,
    firstname,
    lastname,
    telephone,
    postcode,
    provinceName,
    districtName,
    premise,
    neighborhood,
    landmark,
    buildingNumber,
    district,
    region,
    regionCode,
    shortAddress,
  } = address;

  return {
    is_pickup_address: isPickupAddress,
    pickup_information: pickupInformation ? JSON.stringify(pickupInformation) : undefined,
    street: [streetName, streetNumber, streetAdditional],
    company: "",
    region: region?.region ?? "",
    region_id: region?.region_id ?? 0,
    city,
    country_code: countryCode,
    firstname,
    lastname,
    telephone,
    postcode,
    save_in_address_book: saveInAddressBook,
    administrative_area_level_2: provinceName,
    sublocality_level_2: districtName,
    premise,
    neighborhood,
    landmark,
    building_number: buildingNumber,
    district,
    region_code: regionCode,
    short_address: shortAddress,
  };
};
